import classNames from "classnames";
import React from "react";

import type { BaseCartLine } from "@repo/shopify/types/generated/storefront.types";
import { getDiscountName } from "@repo/shopify/utils/order";

import Price from "@atoms/Price";

interface ICheckoutLineItemProps {
  node: BaseCartLine;
  /** 배송 불가 국가명. 값이 있으면 배송 불가 상품으로 표시 */
  unshippableCountry?: string;
}

export default function CheckoutLineItem({ node, unshippableCountry }: ICheckoutLineItemProps) {
  const compareAtPrice = parseFloat(node.cost.compareAtAmountPerQuantity?.amount || "0") * node.quantity;
  const price = parseFloat(node.cost.amountPerQuantity.amount) * node.quantity;
  const discountPrice = parseFloat(node.cost.totalAmount.amount);

  const isLimited = Boolean(unshippableCountry);
  const dimmed = isLimited ? "text-grey" : "";

  return (
    <React.Fragment key={node.id}>
      <div className={classNames("col-span-4", dimmed)}>
        <span>{node.merchandise.product.title}</span>
        <span className="ml-1 font-normal">{node.merchandise.title.replace(" /", ",")}</span>
      </div>
      <span className={classNames("col-span-1 flex justify-end", dimmed)}>{`Qty ${node.quantity}`}</span>

      <div className={classNames("col-span-3 flex flex-col items-end", dimmed)}>
        <Price
          className="text-right"
          compareAtPrice={compareAtPrice ? compareAtPrice : price}
          direction="vertical"
          price={discountPrice}
          variant="secondary"
        />
        {node.discountAllocations.length ? (
          <>
            {node.discountAllocations.map((discount) => (
              <span className="text-xs font-normal capitalize" key={getDiscountName(discount)}>
                {getDiscountName(discount)}
              </span>
            ))}
          </>
        ) : null}
      </div>

      {isLimited ? (
        <span className="text-dark-grey col-span-8">
          * This item can&apos;t be shipped to {unshippableCountry}. Please remove the item from cart.
        </span>
      ) : null}
    </React.Fragment>
  );
}
